module.exports = "/assets/site/images/foldgaztarolo_feher.png?3ca7987091c0584bd139b4b77c6781a5";